import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { Row, Col, Button, Table, Form } from 'react-bootstrap';
import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';
import { resetPagination, togglePrompt } from '../../../store/actions/commonActions';
import { fetchActivities, 
    filterActivities, 
    clearActivities, 
    enableActivity, 
    disableActivity, 
    ACTIVE, 
    INACTIVE, 
    RESET_ACTIVITIES_PAGINATION, 
    SET_ACTIVITIES_PAGINATION } from '../../../store/actions/activities/activitiesActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheckSquare, faPen } from '@fortawesome/free-solid-svg-icons';
import { ConfirmDialog } from '../../../common/Utilities';

import PageTitle from '../../../common/PageTitle';
import ListPagination from '../../../common/ListPagination';

class Activities extends Component {

  constructor(props) {
    super(props);
    this.showDisableActivities = false;
    this.enableActivity = 'ENABLE_ACTIVITY';
    this.disableActivity = 'DISABLE_ACTIVITY';

    this.pathname = this.props.location.pathname;
    this.roleId = Cache.getItem('roleId');
  }

  componentDidMount() {
    let filters = { 
      active: ACTIVE
    }

    if (this.pathname === '/settings/tasks/disabled') {
      filters = { 
        active: INACTIVE 
      }
      this.showDisableActivities = true;
    }
    else {
      this.showDisableActivities = false;
    }

    if (this.roleId === PORTAL_ADMIN || this.roleId === PROJECT_ADMIN) {
      this.props.fetchActivities(filters);
      this.props.resetPagination(RESET_ACTIVITIES_PAGINATION);
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  promptModal = () => {
    let modalTitle = '';
    let modalBody = '';
    let verb = '';

    if (this.action === this.enableActivity) {
      modalTitle = 'Enable Task';
      verb = 'enable';
    }
    else {
      modalTitle = 'Disable Task';
      verb = 'disable';
    }

    modalBody = 'Are you sure you want to ' + verb + ' this task?';
    
    const onHideFunction = () => {
      this.props.togglePrompt(false);
    }

    const onClickCancel = () => {
      this.props.togglePrompt(false);
    }

    const onClickConfirm = () => {
      if (this.action === this.enableActivity) {
        this.props.enableActivity(this.activity.id);
      }
      else {
        this.props.disableActivity(this.activity.id);
      }
      this.props.togglePrompt(false);
      this.props.resetPagination(RESET_ACTIVITIES_PAGINATION);
    }

    return (
      <ConfirmDialog 
        show={this.props.common.togglePrompt} 
        modalTitle={modalTitle} 
        modalBody={modalBody} 
        onHideFunction={onHideFunction}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
      />
    ) 
  }

  filterActivities = () => {
    return (
      <Form.Control size="xl" type="search" placeholder="Filter Tasks" onChange={(e) => {
        const filter = e.target.value;
        this.props.filterActivities(filter);
      }} />
    )
  }

  getFilteredActivities = (activities) => {
    if (!activities) {
      return null;
    }

    return activities.filter(activity => {
      const activityName = activity.name || '';
      const activityCode = activity.activity_code || '';

      const activityData = [
        activityName,
        activityCode,
      ].join(" ").toLowerCase();
      
      const activityFilter = this.props.activities.activityFilter; 

      if (!activityFilter || activityData.includes(activityFilter.toLowerCase())) {
        return activity;
      }
      return null;
    })
  }

  updateActivity = (activityCode) => {
    this.props.history.push('/settings/tasks/update?code=' + activityCode)
  }


  renderActivities = () => {
    let activities = this.getFilteredActivities(this.props.activities.activities);

    if (activities) {
       //if the user tries to search and no matches the filter
      if (this.props.activities.activityFilter && !activities.length) {
        activities = null;
      }
      else {
        let min = this.props.activities.min;
        let max = this.props.activities.max;
        
        if (!this.props.activities.activityFilter) {
          activities = activities.slice(min - 1, max);
        }
      }
    }
    
    let activityList = [];

    if (activities) {
      activityList = activities.length ? (
        activities.map((activity, key) => {
          return (
            <tr key={key}>
              <td>{activity.name}</td>
              <td className="float-right tbl-funcs tbl-funcs-impo">
              {
                activity.active ? 
                <Button size="sm" className="btn-primary" onClick={() => {
                  this.activity = activity;
                  this.action = this.disableActivity;
                  this.props.togglePrompt(true);
                }}>
                  <FontAwesomeIcon icon={faCheckSquare} /> Disable
                </Button> : 
                <Button size="sm" className="btn-primary" onClick={() => {
                  this.activity = activity;
                  this.action = this.enableActivity;
                  this.props.togglePrompt(true);
                }}>
                  <FontAwesomeIcon icon={faBan} /> Enable
                </Button>
              }
              <Button size="sm" className="btn-primary" onClick={() => this.updateActivity(activity.activity_code)}>
                <FontAwesomeIcon icon={faPen} /> Edit
              </Button>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={2}>Loading....</td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={2}><p className="text-danger">No tasks found.</p></td>
        </tr>
      )
    }

    return activityList;
  }

  render() {
    let listPagination = '';
    const activities = this.props.activities.activities;

    if (!this.props.activities.activityFilter && activities) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination 
            dispatchType={SET_ACTIVITIES_PAGINATION}
            data={this.props.activities.clients} 
            min={this.props.activities.min}
            max={this.props.activities.max}
            currentPage={this.props.activities.currentPage} 
            totalPages={this.props.activities.totalPages} 
            fetchCallback="" 
            numItems={this.props.activities.numItems} />
        </div>
      )
    }

    const addActivity = <Button id="add-activity" size="sm" onClick={() => {
      this.props.history.push('/settings/tasks/add')
    }}>Add Task</Button>
    

    return (
      <>
        { this.promptModal() }
        <PageTitle pageName={this.showDisableActivities ? "Disabled Tasks" : "Tasks"} actionButton={addActivity} />
        <Row className="mt-3">
          <Col>
            {this.showDisableActivities ? (
              <Button variant="outline-secondary" size="sm" onClick={() => {
                this.props.history.push('/settings/tasks');
                this.showDisableActivities = false;
                this.props.resetPagination(RESET_ACTIVITIES_PAGINATION);
                this.props.clearActivities();
                this.props.fetchActivities({active: 1});
              }}>
                Show Active Tasks
              </Button> 
            ) : (
              <Button variant="outline-secondary" size="sm" onClick={() => {
                this.props.history.push('/settings/tasks/disabled');
                this.showDisableActivities = true;
                this.props.resetPagination(RESET_ACTIVITIES_PAGINATION);
                this.props.clearActivities();
                this.props.fetchActivities({active: 0});
              }}>
                Show Disabled Tasks
              </Button> 
            )}
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="float-right">
              {listPagination}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table>
              <thead>
                <tr>
                  <th className="align-center">Task Name</th>
                  <th className="align-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={2}>
                    { this.filterActivities() }
                  </td>
                </tr>
                { this.renderActivities() }
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToDispatch = (state) => ({
  activities: state.activities,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => ({
  resetPagination: (...args) => dispatch(resetPagination(...args)),
  fetchActivities: (...args) => dispatch(fetchActivities(...args)),
  filterActivities: (...args) => dispatch(filterActivities(...args)), 
  clearActivities: () => dispatch(clearActivities()),
  togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  enableActivity: (...args) => dispatch(enableActivity(...args)), 
  disableActivity: (...args) => dispatch(disableActivity(...args))
})

export default withRouter(connect(mapStateToDispatch, mapDispatchToProps)(Activities))
